import React from 'react';
import { XIcon, LockIcon } from 'lucide-react';
import { DS } from './ds';
import { GoogleSignInButton } from './GoogleSignInButton';
interface BlogLoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginSuccess: () => void;
}
export const BlogLoginModal = ({
  isOpen,
  onClose,
  onLoginSuccess
}: BlogLoginModalProps) => {
  if (!isOpen) return null;
  return <div role="dialog" aria-modal="true" aria-label="Acceso al blog" style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(11,31,36,0.5)',
    zIndex: 1100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  }} data-id="element-69" data-mp="o1b23aw4l1l">
      <div style={{
      position: 'relative',
      background: '#fff',
      borderRadius: DS.radius.cardLg,
      padding: '40px',
      maxWidth: '420px',
      width: '100%',
      boxShadow: '0 20px 60px rgba(11,31,36,0.3)'
    }} data-id="element-70" data-mp="5o5r5s7vzdra">
        <button type="button" onClick={onClose} aria-label="Cerrar" style={{
        position: 'absolute',
        top: '16px',
        right: '16px',
        background: DS.color.mint,
        border: 'none',
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: DS.color.tealDeep
      }} data-id="element-71" data-mp="2ea1laobw5nrm">
          <XIcon size={16} aria-hidden="true" data-id="element-72" data-mp="320nrsb68yzzi" />
        </button>

        <div style={{
        width: '52px',
        height: '52px',
        borderRadius: '50%',
        background: DS.color.mint,
        color: DS.color.tealDeep,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 20px'
      }} data-id="element-73" data-mp="36z8sebpevloh">
          <LockIcon size={22} aria-hidden="true" data-id="element-74" data-mp="2jw5jnbqordrq" />
        </div>

        <h2 style={{
        fontFamily: DS.font.heading,
        fontSize: '22px',
        fontWeight: 700,
        color: DS.color.ink,
        textAlign: 'center',
        margin: '0 0 10px'
      }} data-id="element-75" data-mp="2jyi0flkpji37">
          Contenido para profesionales
        </h2>
        <p style={{
        fontFamily: DS.font.body,
        fontSize: '14px',
        color: DS.color.body,
        textAlign: 'center',
        margin: '0 0 28px',
        lineHeight: 1.6
      }} data-id="element-76" data-mp="2oxl8zfzwc6fx">
          Inicia sesión con tu cuenta de Google y verifica tu email
          profesional para acceder a los artículos exclusivos.
        </p>

        <GoogleSignInButton onSuccess={onLoginSuccess} data-id="element-77" data-mp="37mrq4yl1kpzm" />
      </div>
    </div>;
};